import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { LinkBtn } from '@manychat/manyui'

import { useAppSelector } from 'reduxTyped'
import { getLoggedIn } from 'common/core/selectors/appSelectors'

export const DevRedirectionManagerController = () => {
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const isLoggedIn = useAppSelector(getLoggedIn)
  const [errorMessage, setErrorMessage] = useState<string | null>(null)

  useEffect(() => {
    if (!isLoggedIn) {
      return
    }

    if (pathname === '/' || pathname.endsWith('/refreshPermissions')) {
      navigate('/profile/dashboard')
    }
  }, [isLoggedIn, navigate, pathname])

  useEffect(() => {
    if (!isLoggedIn) {
      setErrorMessage('Valid cookie is missing in the env file')
    } else if (pathname === '/addFbAccount') {
      setErrorMessage("You're trying to access the page, that doesn't exist in this repository 🛸")
    } else {
      setErrorMessage(null)
    }
  }, [pathname, isLoggedIn])

  if (errorMessage) {
    const href = process.env.MC_API_ROOT
    return (
      <div style={{ height: '100vh' }} className="d-flex align-center justify-center">
        <div className="text-center">
          <h1>⚙️{errorMessage}</h1>

          <LinkBtn
            variant="primary"
            href={href}
            target="_blank"
            className="d-inline-block m-x-auto m-t"
          >
            Open <span className="text-lowercase">{href?.toLocaleLowerCase()}</span>
          </LinkBtn>
        </div>
      </div>
    )
  }

  return null
}
